import { Component } from 'react'
import IconSVG from 'svg-inline-react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Button, Icon } from '@driftt/tide-core-legacy'
import { showNotification, soundNotification } from 'utils/NotificationHelper'
import { NEVER_SHOW } from '../../constants'
import { track } from 'app/modules/tracking/actions'


const BellIcon = require('!svg-inline?removeTags=true!images/svg/message-alert.svg')

class EnableNotifications extends Component {

  constructor(props) {
    super(props)

    this.state = {
      closed: true,
      stage: 'initial',
    }

    this.setClose = this.setClose.bind(this)
    this.fuckOff = this.fuckOff.bind(this)
    this.showConfirm = this.showConfirm.bind(this)
    this.setOpen = this.setOpen.bind(this)
    this.hideForSession = this.hideForSession.bind(this)
    this.enableNotifications = this.enableNotifications.bind(this)
    this.showInstructions = this.showInstructions.bind(this)
  }

  componentDidMount() {
    if(window.sessionStorage && JSON.parse(!!!window.sessionStorage.getItem('hide-notifications-message')) ) {
      setTimeout(this.setOpen, 5000)
    }
  }

  hideForSession() {
    this.props.actions.track('Browser Notifications Banner Dismissed Until Next Session')
    if (window.sessionStorage) {
      window.sessionStorage.setItem('hide-notifications-message', true)
    }

    this.setClose()
  }

  showConfirm() {
    this.props.actions.track('Browser Notifications Banner Dismissed')
    this.setState({ stage: 'confirm'})
  }

  showInstructions() {
    this.setState({ stage: 'instructions'})
  }

  setClose() {
    this.setState({closed: true})

  }

  setOpen() {
    this.setState({ closed: false })
  }

  fuckOff() {
    this.props.actions.track('Browser Notifications Banner Permanently Dismissed')
    this.setClose()
    window.localStorage.setItem(NEVER_SHOW, true)
  }

  sendTest() {
    const message = "Hey look!"
    const opts = {
      icon: require('images/notification-logo.png'),
      tag: "",
      body: "You now will receive browser notifications 🚀"
    }
    const handle = () => {
      window.open('/inboxes')
    }
    showNotification(message, opts, handle)
    soundNotification()
  }

  enableNotifications() {
    this.showInstructions()
    this.props.actions.track('Enable Browser Notification Button Pressed', {stage: this.state.stage})
    Notification.requestPermission((permission) => {
      if (permission === "granted") {
        this.sendTest()
        this.setClose()
        this.props.actions.track('Browser Notifications Enabled')
      } else if (permission === "denied") {
        this.props.actions.track('Browser Notifications Blocked')
      }
    })
  }

  renderEnable() {
    const showBar = !this.state.closed ? 'show-bar' : ''
    return (
      <div className={`global-notification-tease attention ${ showBar }`}>
        <p>Drift needs your permission to enable browser notifications</p>
        <Button type="tertiary" className="notification-button drift-button small" onClick={this.enableNotifications}>
         <Icon name="notification" width={12}/>
           Enable browser notifications
         </Button>
        <div className="dismiss-notification" onClick={ this.showConfirm }> <Icon name="close" /> </div>
      </div>
    )
  }

  renderInstructions() {
    const showBar = !this.state.closed ? 'show-bar' : ''
    return (
      <div className={`global-notification-tease instruction ${ showBar }`}>
        <p>
          Click "Allow" in your browser’s pop-up window to enable desktop notifications.
        </p>
        <div className="dismiss-notification" onClick={ this.showConfirm }> <Icon name="close" /> </div>
      </div>
    )
  }

  renderConfirm() {
    const showBar = !this.state.closed ? 'show-bar' : ''
    return (
      <div className={`global-notification-tease attention ${ showBar }`}>
        <p>We strongly recommend enabling desktop notifications if you’ll be using Drift on this computer - we don’t want you to miss any conversations!</p>
        <div className="notifications-dissmiss-actions">
          <Button type="tertiary" className="notification-button drift-button small" onClick={this.enableNotifications}>Enable desktop notifications</Button>
          <Button type="tertiary" className="notification-button drift-button small" onClick={this.hideForSession}>Ask me next time</Button>
          <Button type="tertiary" className="notification-button drift-button small" onClick={this.fuckOff}>Never ask again on this computer</Button>
        </div>
        <div className="dismiss-notification" onClick={ this.hideForSession }> <Icon name="close" /> </div>
      </div>
    )
  }

  render() {
    switch(this.state.stage) {
      case 'instructions':
        return this.renderInstructions()
      case 'confirm':
        return this.renderConfirm()
      default:
      return this.renderEnable()
    }
   }

}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      track
    }, dispatch)
  }
}

export default compose(
  connect(null, mapDispatchToProps),
)(EnableNotifications)



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalNotificationBar/components/EnableNotifications/index.js